module.exports = __webpack_public_path__ + "static/img/erweima.20dfc077.png";